/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/05 15:10
 * Description:
 */
import { SET_BREADCRUMB } from '../mutations';
const moduleModalPages = {
    state: {
        breadcrumb: []
    },
    mutations: {
        [SET_BREADCRUMB] (state, breadcrumb) {
            state.breadcrumb = breadcrumb;
        }
    },
    actions: {
    },
    getters: {}
};

export default moduleModalPages;
